import { z } from "zod";
import { defineControl, placeholderFieldSchema } from "./field.js";
export const multilineText = defineControl({
    key: "multilineText",
    label: "Multiline text field",
    schema: placeholderFieldSchema("multilineText"),
    answer: z.string(),
    isClearable: true,
    empty: { placeholder: "", required: false },
});
